import { collectionPublishReadiness } from '@platform/client';

/**
 * What stops a collection publishing, asked the same way from both screens that ask.
 *
 * The key is here rather than written out twice because the publish mutation invalidates
 * it: a key that drifted on one screen would leave the other showing `9 unmet` after a
 * successful publish, with nothing failing anywhere.
 *
 * `staleTime` is generous and focus refetching is off. A finished module's readiness does
 * not change on its own, and a job holds up to fifty rows — a tab-back would otherwise
 * re-ask fifty times. Publishing invalidates, which ignores both.
 */
export const publishReadinessQuery = (id: string) => ({
  queryKey: publishReadinessKey(id),
  queryFn: () =>
    collectionPublishReadiness({ path: { id }, throwOnError: true }),
  staleTime: 5 * 60 * 1000,
  refetchOnWindowFocus: false,
});

export const publishReadinessAll = ['publish-readiness'];

export const publishReadinessKey = (id: string) => [...publishReadinessAll, id];
